import { ERROR_FRAGMENT } from 'providers/tanstack-query/errors'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data, Variables } from './types'

export const UPLOAD_AD_UNITS_CONFIGURATION: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${ERROR_FRAGMENT}

  mutation uploadAdUnitsConfiguration($input: UploadAdUnitsXlsInput!) {
    uploadAdUnitsXls(input: $input) {
      errors {
        ...ErrorFragment
      }
    }
  }
`
